export const languages = [
   {
      lang: 'en',
      name: 'English',
      flag: './media/flags/united-states.svg',
   },
   {
      lang: 'ar',
      name: 'Arabic',
      flag: './media/flags/Flag_of_the_Arab_League_(1-2).svg',
   }
];
